import React, { useState, useEffect } from 'react';
import { LinearProgress } from '@mui/material';

import BrandGroupRolodex from 'ui/BrandGroupRolodex';
import { useQueryString } from 'hooks/useQueryString';
import { CatalogService } from 'api/catalog/services';
import { IBrands } from 'api/catalog/models';
import BrandListing from 'ui/BrandListing';
import NoResults from 'ui/ErrorDisplay/NoResults';
import ServiceError from 'ui/ErrorDisplay/ServiceError';
import PageWrapper from 'ui/PageWrapper';

const PageBrands = () => {
  const { parsedQueryString } = useQueryString();

  const [brands, setBrands] = useState<IBrands>();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setIsError(false);
    CatalogService.getBrands({ ...parsedQueryString })
      .then((res) => {
        setBrands(res.data);
      })
      .catch((err) => {
        setIsError(true);
        console.warn('err: ', err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [parsedQueryString]);

  return (
    <PageWrapper>
      <BrandGroupRolodex />
      {isLoading ? (
        <LinearProgress sx={{ width: '100%' }} />
      ) : isError ? (
        <ServiceError />
      ) : !brands?.brands?.length ? (
        <NoResults />
      ) : (
        <BrandListing brands={brands} />
      )}
    </PageWrapper>
  );
};

export default PageBrands;
